import { inject, Injectable } from '@angular/core';
import { CapacitorService } from '@libs/shared/common';
import { CustomerModel } from '@libs/account/models';
import { Subscription } from 'rxjs';
import { CustomersState } from '../state';

@Injectable({
  providedIn: 'root',
})
export class CustomerUpdateService {
  private readonly customerState: CustomersState = inject(CustomersState);
  private readonly capacitorService: CapacitorService = inject(CapacitorService);
  private customerUpdateSubscription: Subscription = new Subscription();

  public initCustomerUpdateOnResume(): void {
    if (!this.capacitorService.isCapacitorApp()) {
      return;
    }

    this.removeCustomerUpdateOnResume();

    this.customerUpdateSubscription.add(
      this.capacitorService.resume$()
        .subscribe(() => {
          // there are side effect when you are on the start page that close the dialog if we do not check this
          this.capacitorService.isNativeAppUpdateAvailable().subscribe((updateAvailable) => {
            if (updateAvailable) {
              return;
            }

            void this.fetchCurrentCustomer();
          });
        }));
  }

  public removeCustomerUpdateOnResume(): void {
    this.customerUpdateSubscription.unsubscribe();
    this.customerUpdateSubscription = new Subscription();
  }

  private fetchCurrentCustomer(): Promise<CustomerModel | undefined> {
    const current: CustomerModel | undefined = this.customerState.currentCustomer();

    if (!current) {
      // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
      return Promise.reject('Shop Customer id is empty');
    }

    return this.customerState.fetchCustomer(current);
  }
}
